import { render, staticRenderFns } from "./EditChoirModal.vue?vue&type=template&id=12fadbf9&scoped=true&"
import script from "./EditChoirModal.vue?vue&type=script&lang=ts&"
export * from "./EditChoirModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditChoirModal.vue?vue&type=style&index=0&id=12fadbf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fadbf9",
  null
  
)

export default component.exports